var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
export var getHref = function (item) {
    return item.href;
};
var isCategoryDisabled = function (category) {
    return category.disabled || (category.items.length > 0 && category.items.every(function (item) { return item.disabled; }));
};
var ItemElement = function (_a) {
    var item = _a.item, isDisabled = _a.isDisabled, prefixClass = _a.prefixClass, activateItem = _a.activateItem, isSelected = _a.isSelected;
    var href = getHref(item);
    var className = [
        prefixClass('item'),
        href && prefixClass('item-link'),
        isSelected && prefixClass('item-highlighted'),
        isDisabled && prefixClass('item-disabled')
    ]
        .filter(function (className) { return className; })
        .join(' ');
    var attributes = {
        className: className,
        role: 'menuitem',
        'data-testid': item.id,
        'data-description': item.description,
        'aria-disabled': isDisabled ? 'true' : undefined,
        // We are using the roving tabindex technique to manage the focus state of the dropdown.
        // The current element will always have tabindex=0 which means that it can be tabbed to,
        // while all other items have tabindex=-1 so we can focus them when necessary.
        tabindex: isDisabled ? undefined : isSelected ? 0 : -1
    };
    var onClick = function (event) {
        !href && event.preventDefault();
        !isDisabled && activateItem(item, event);
    };
    return !href ? (AwsUi.__createElement("li", __assign({}, attributes, { onclick: onClick }), item.text)) : (AwsUi.__createElement("li", __assign({}, attributes),
        AwsUi.__createElement("a", { href: href, onclick: onClick }, item.text)));
};
var CategoryElement = function (_a) {
    var item = _a.item, prefixClass = _a.prefixClass, createItems = _a.createItems;
    var categoryDisabled = isCategoryDisabled(item);
    var className = [prefixClass('category'), categoryDisabled && prefixClass('category-disabled')]
        .filter(function (className) { return className; })
        .join(' ');
    var attributes = {
        className: className,
        role: 'presentation',
        'aria-disabled': categoryDisabled ? 'true' : undefined
    };
    // Hide the category title element from screen readers because it will be
    // provided as an ARIA label.
    return (AwsUi.__createElement("li", __assign({}, attributes),
        item.text && (AwsUi.__createElement("p", { className: prefixClass('category-header'), "aria-hidden": "true" }, item.text)),
        AwsUi.__createElement("ul", { className: prefixClass('items'), role: "group", "aria-label": item.text }, createItems(item.items, categoryDisabled))));
};
export var DropdownItemsCreator = function (_a) {
    var getHighlightedItem = _a.getHighlightedItem, activateItem = _a.activateItem, prefixClass = _a.prefixClass;
    var createItems = function (items, categoryDisabled) {
        if (categoryDisabled === void 0) { categoryDisabled = false; }
        return items.map(function (item) {
            var props = {
                item: item,
                prefixClass: prefixClass
            };
            if (item.items) {
                var categoryProps = __assign(__assign({}, props), { createItems: createItems });
                return AwsUi.__createElement(CategoryElement, __assign({}, categoryProps));
            }
            var itemProps = __assign(__assign({}, props), { activateItem: activateItem, isDisabled: item.disabled || categoryDisabled, isSelected: item === getHighlightedItem() });
            return AwsUi.__createElement(ItemElement, __assign({}, itemProps));
        });
    };
    return createItems;
};
//# sourceMappingURL=dropdown-items.js.map